<div class="order-summary" *ngIf="cart$ | async as cart">
  <div class="quote-action col-md-4" [ngClass]="cart?.quoteCartType ? 'disabled': ''">
    <button class="vs-tertiary-btn" (click)="convertToQuoteCart()" 
    [disabled]="cart?.quoteCartType ? true : false"
    [ngClass]="(checkUserEnabled(accessibility.QUOTABILITYFLAG) | async)  ?'':'hide-btn'">
      <i class='material-icons'>receipt</i>
      {{ "savedCart.getAQuoteLowerCase" | cxTranslate }}
    </button>
  </div>
  
  <div class="summary-details col-md-8 float-right">
    <div class="sub-total" *ngIf="cart.subTotal" [class.mb-2]="cart.orderDiscounts && couponApplied">
      <span class="heading-text float-left">{{ "savedCart.subTotal" | cxTranslate }}</span>
      <span class="float-right content-bold">{{ cart.vsSubTotal?.currencyIso }} {{ cart.vsSubTotal?.formattedValue }}</span>
    </div>
    <div class="coupon-discount" *ngIf="cart.orderDiscounts && couponApplied">
      <span class="heading-text float-left">{{ "savedCart.couponDiscount" | cxTranslate }}</span>
      <span class="float-right content-bold">{{ cart.orderDiscounts?.currencyIso }} {{ getCouponDiscout() }}</span>
    </div>
    <div class="surcharge">
      <span class="heading-text float-left" *ngIf="cart.surCharge">
        {{ "savedCart.surcharge" | cxTranslate }}
        <i class='material-icons' matTooltipClass="vs-tooltip" matTooltip='{{ "savedCart.surchargeTooltipTxt" | cxTranslate}}' matTooltipPosition="above">info</i>
      </span>
      <span class="float-right content-bold">{{ cart.surCharge?.currencyIso }} {{ cart.surCharge?.formattedValue }}</span>
    </div>
    <!-- [ngClass]="cart?.quoteCartType ? 'disabled': ''" -->
    <div *ngIf="!couponApplied" class="coupon-holder" >
      <div class="vs-text-field">
        <input type="text" class="coupon-input" placeholder='{{ "savedCart.enterCouponCode" | cxTranslate }}'
          [(ngModel)]="coupon" (keyup.enter)="applyCoupon()" [class.error]="(couponErrorMsg || noValueCouponMsg) && coupon.length <= 0">
        <label *ngIf="couponErrorMsg && coupon.length <= 0">{{ "savedCart.enterValidCouponCode" | cxTranslate }}</label>
        <label *ngIf="noValueCouponMsg && coupon.length <= 0">{{ "savedCart.couponCodeNotApplicable" | cxTranslate }}</label>
      </div>
      <button class="vs-tertiary-btn apply-btn" (click)="applyCoupon()">{{ "savedCart.apply" | cxTranslate }}</button>
    </div>
    <div *ngIf="couponApplied" class="applied-coupon-holder">
      <span class="applied-coupon-icon mr-2"></span>
      <div class="coupons-holder">
        <span class="applied-coupon">{{ coupon }}</span>
        <span class="applied-coupon-text">{{ "savedCart.couponApplied" | cxTranslate }}</span>
      </div>
      <a (click)="removeCoupon()" class="remove-coupon"><span class="material-icons cancel">cancel</span></a>
    </div>
    <div class="order-price-summary" *ngIf="cart.totalPriceWithTax">
      <span class="float-left">{{ "savedCart.cartTotal" | cxTranslate }} ({{ cart.totalItems }} {{ "savedCart.items" | cxTranslate }}) :</span>
      <span class="float-right">{{ cart.totalPriceWithTax?.currencyIso }} {{ cart.totalPriceWithTax?.formattedValue }}</span>
    </div>
    <div class="order-summary-actions">
      <button (click)="proceedToCheckout()" class="vs-primary-btn proceed-btn">{{ "savedCart.proceedCheckout" | cxTranslate }}</button>
    </div>
  </div>  
</div>



<!-- <h4>{{ 'orderCost.orderSummary' | cxTranslate }}</h4>

<div class="cx-summary-partials" *ngIf="cart">
  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.subtotal' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.subTotal?.formattedValue }}
    </div>
  </div>
  <div class="cx-summary-row">
    <div class="col-6 cx-summary-label">
      {{
        (cart.deliveryCost?.formattedValue
          ? 'orderCost.shipping'
          : 'orderCost.estimatedShipping'
        ) | cxTranslate
      }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{
        cart.deliveryCost?.formattedValue
          ? cart.deliveryCost.formattedValue
          : 'TBD'
      }}
    </div>
  </div>
  <div class="cx-summary-row" *ngIf="cart.net">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.salesTax' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.totalTax?.formattedValue }}
    </div>
  </div>
  <div class="cx-summary-row cx-summary-total">
    <div class="col-6 cx-summary-label">
      {{ 'orderCost.total' | cxTranslate }}
    </div>
    <div class="col-6 cx-summary-amount">
      {{ cart.totalPriceWithTax?.formattedValue }}
    </div>
  </div>
  <div class="cx-summary-row" *ngIf="cart.totalDiscounts?.value > 0">
    {{ 'orderCost.discount' | cxTranslate }}
    {{ cart.totalDiscounts?.formattedValue }}
  </div>
  <div class="cx-summary-row" *ngIf="!cart.net">
    {{ 'orderCost.grossTax' | cxTranslate }}
    {{ cart.totalTax?.formattedValue }}.
  </div>
</div> -->

<!--
<cx-promotions
  *ngIf="cart"
  [promotions]="cart.appliedOrderPromotions"
></cx-promotions>
-->
<!-- 
<ng-container *cxFeatureLevel="'1.3'">
  <cx-applied-coupons
    [vouchers]="cart.appliedVouchers"
    [isReadOnly]="true"
  ></cx-applied-coupons>
</ng-container> -->
